import { AccountChipWrapper, AccountDot } from "./styles";
import { AccountChipProps } from "./types";
import { getAccountDotColor } from "./utils";

export const AccountChip: React.FC<AccountChipProps> = ({
  name,
  accountId,
  accountIdsByName,
}) => {
  if (!name) {
    return null;
  }
  const matchedAccountId = accountId ?? accountIdsByName.get(name);

  return (
    <AccountChipWrapper>
      <AccountDot $color={getAccountDotColor(name, matchedAccountId)} />
      {name}
    </AccountChipWrapper>
  );
};
